export const initialState = {
  site: {
    global: {
      loginOverlayVisible: false
    }
  }
}